module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5P0NC"))).then(() => parcelRequire('aPBGq'));